export default __webpack_public_path__ + "images/2856e294244c148105e6167fc61a5170.svg";